export const MATERIAL_MAX_CHARS = 100;
export const CAD_FILENAME_MAX_CHARS = 100;

export const cadFilenameValidationMessage = (
  fileName: string,
): string | null =>
  fileName.length > CAD_FILENAME_MAX_CHARS
    ? `Filename must be ${CAD_FILENAME_MAX_CHARS} characters or fewer.`
    : null;
